<template>
  <v-form v-model="valid" ref="form" lazy-validation>
    <v-layout row wrap>
      <v-flex xs12 v-if="aluno">
        <v-textarea name="Doença ou Alergia" v-model="result.doenca" label="Doença ou Alergia"></v-textarea>
        <v-textarea
          name="Tratamento e Remedios"
          v-model="result.tratamento"
          label="Tratamento e Remedios"
        ></v-textarea>
        <v-textarea name="Restrições" v-model="result.restricao" label="Restrições"></v-textarea>
        <v-autocomplete
          label="Mediador"
          :items="listamediador"
          item-text="username"
          v-model="result.mediador"
          max-height="400"
          hint="Escolha o responsável pelo aluno"
          persistent-hint
        ></v-autocomplete>
        <v-autocomplete
          label="Turma"
          :items="turma"
          item-text="name"
          item-value="slug"
          multiple
          v-model="result.turma_set"
          max-height="400"
          hint="Escolha a turma"
          persistent-hint
        ></v-autocomplete>
        <div v-if="!isMakerlab">
          <h3>*Familiares :</h3>
          <v-flex xs-8 v-if="parentData.first_name != null">
            <v-data-table :headers="headers" :items="rows" :search="search">
              <template slot="items" slot-scope="props">
                <td>{{ parentData.first_name }}</td>
                <td>{{ parentData.parentesco }}</td>
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning"
              >Sua busca por "{{ search }}" não encontrou resultados.</v-alert>
            </v-data-table>
          </v-flex>
          <v-btn
            color="primary"
            flat
            @click.stop="existe = true, selecao = false"
          >Parentes existentes</v-btn>
          <v-btn
            color="primary"
            flat
            @click.stop="cadparente = true, selecao = false"
          >Adicionar Novo</v-btn>
        </div>
        <v-spacer></v-spacer>
        <v-flex xs12>
          <v-select
            v-if="selecao"
            :key="familia.parente"
            v-model="familiares"
            :items="familiares"
            item-text="parente.username"
            chips
            return-object
            label="Lista de parentes"
            multiple
          ></v-select>
        </v-flex>
        <!-- Dialog - parente existente -->
        <v-dialog
          v-model="existe"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
          scrollable
        >
          <dialog-parente @close="existe=false, selecao = true" @existente="atualdados"></dialog-parente>
        </v-dialog>
        <v-dialog
          v-model="cadparente"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <!-- Dialog - cadastro parente -->
          <cadastro-parente
            @close="cadparente=false, selecao = true"
            @parenteDados="atualdados"
            :step2Data="step2Data"
            :step1Data="step1Data"
            v-if="!isMakerlab"
          ></cadastro-parente>
        </v-dialog>
      </v-flex>
      <v-flex xs12 v-if="!aluno">
        <!-- <v-select
          label="Tipo de profissional"
          :items="profissoes"
          item-text="username"
          autocomplete
          v-model="result.tipoprof"
          max-height="400"
        ></v-select>-->
        <v-text-field label="Nacionalidade" v-model="result.nacionalidade"></v-text-field>
        <v-text-field label="Estado de nascimento" v-model="result.estadonasc" mask="AA"></v-text-field>
        <v-text-field label="Cidade" v-model="result.cidadenasc"></v-text-field>
      </v-flex>
      <v-btn color="primary" @click.native="$emit('prev')">Voltar</v-btn>
      <v-btn color="primary" @click.native="proximo">Continuar</v-btn>
    </v-layout>
    <v-snackbar v-model="snackbar" bottom color="red">Parente responsável financeiro é obrigatório.</v-snackbar>
  </v-form>
</template>

<script>
import api from '@/api';
import DialogParente from '@/components/reusable/DialogParente.vue';
import CadastroParente from '@/components/reusable/CadastroParente.vue';
export default {
  components: {
    DialogParente,
    CadastroParente
  },
  props: ['step2Data', 'step1Data'],
  data () {
    return {
      groupsOptions: ['Aluno', 'Mediador', 'Admin'],
      genero: ['Feminino', 'Masculino', 'Outro'],
      profissoes: [
        'CEO',
        'Secretário',
        'Faxineiro',
        'Orientador',
        'Cozinheiro',
        'Ajudante',
        'Pedagogo'
      ],
      result: {
        familiares: {}
      },
      existe: false,
      cadparente: false,
      selecao: false,
      snackbar: false,
      programas: [],
      listamediador: [],
      parentData: {},
      turma: [],
      aluno: false,
      chip: true,
      familia: [],
      familiares: [],
      options: {},
      emailRules: [
        v => !!v || 'E-mail é obrigatório',
        v =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          'E-mail incorreto'
      ],
      valid: true,
      menu2: false
    };
  },
  mounted () {
    if (this.isMediador) {
      this.projetoData.moderador = this.$store.state.user.username;
      this.getStudents(this.projetoData.moderador);
    } else {
      api.request('GET', 'search-user?groups__name=Mediador').then(resp => {
        this.listamediador = resp.data;
      });
    }
    this.$watch('moderador', function () {
      this.projetoData.moderador = this.moderador.username;
      this.getStudents(this.projetoData.moderador);
    });
    this.$watch('step1Data', function () {
      if (this.step1Data.groups[0] === 'Aluno') {
        this.aluno = true;
      } else {
        this.aluno = false;
      }
    });
  },
  created () {
    let username = this.$store.state.user.username;
    api.request('GET', 'user-edit-options/' + username + '/').then(response => {
      this.options = response.data;
    });
    api.request('GET', 'search-user?groups__name=Parente').then(response => {
      this.familia = response.data;
    });
    api.request('GET', 'programas/').then(response => {
      this.programas = response.data;
    });
    api.request('GET', 'turmas/').then(response => {
      this.turma = response.data;
    });
  },
  computed: {
    isMakerlab () {
      return this.$store.state.company.makerlab;
    },
    isMediador () {
      return this.$store.state.selectedRole.name === 'Mediador';
    },
    isStudent () {
      return this.$store.state.selectedRole.name === 'Aluno';
    },
    isAdmin () {
      return this.$store.state.selectedRole.name === 'Admin';
    },
    isAluno () {
      return this.step1Data.groups[0] === 'Aluno';
    },
    atualparenteData (parente) {
      this.parentData = parente;
    }
  },
  methods: {
    proximo () {
      if (this.aluno) {
        // console.log(this.familiares)
        if (this.isMakerlab) {
          delete this.result.familiares
          this.$emit('dados3', this.result);
          this.$emit('next');
        }
        for (let index = 0; index < this.familiares.length; index++) {
          if (this.familiares[index].respfinanceiro === true) {
            var fin = this.familiares[index].respfinanceiro;
          }
        }
        if (fin) {
          this.result.familiares = this.familiares;
          this.$emit('dados3', this.result);
          this.$emit('dadosparente', this.parentData);
          this.$emit('next');
        } else {
          this.snackbar = true;
        }
      } else {
        this.result.familiares = this.familiares;
        this.$emit('dados3', this.result);
        this.$emit('dadosparente', this.parentData);
        this.$emit('next');
      }
    },
    atualdados (dados) {
      this.familiares.push(dados);
      console.log(this.familiares);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Usuarios/CadastroSteps/Step3.vue